module.exports = __webpack_public_path__ + "img/congratulations.19080be8.png";